export default defineNuxtPlugin((nuxtApp) => {
	const BASE_URL = useRuntimeConfig().public.apiUrl;

	return {
		provide: { 
			images: (file_id, file_size) => {
				if (!file_id) return "/images/placeholder.svg";

				let url = `${BASE_URL}/assets/${file_id}`;
				if (file_size) {
					url += `?key=${file_size}`;
				}
				return url;
			}
		}
	};
})

// file_size è impostato per
// small (360w)
// medium (500w)
// large (800w)
// big (1900w)